import { InputNumber } from "antd";
import { useAdvancedFormContext } from "../advanced-form";
import styled from "styled-components";


export const InputNumberStyled = styled(InputNumber)`
  .ant-input-number-readonly {
    background: none;
  }

  input.ant-input-number-input {
    text-align: right;
    padding-right: 2em;
  }

  input[readonly] {
    background: none;
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }
`

function FormItemCurrency({value, onChange, readOnly}: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  return <>
    <InputNumberStyled<number>
      style={{ width: '100%' }}
      formatter={(value, { userTyping }) => { 
        if(userTyping) {
          return `${value}`.replace('.', ',');
        }
        if(`${value}`.indexOf('.') !== -1) {
          const [euro, cent] = `${value}`.split('.');
          const result = `${euro},${cent.length === 1 ? `${cent}0` : cent}`;
          console.log("Result", result);
          return result;
        } else if(`${value}`.length === 0) {
          return '';
        } else {
          return `${value},00`;
        }
      }}
      min={0}
      step={0.5}
      decimalSeparator=','
      onChange={onChange}
      addonAfter="€"
      value={value}
      readOnly={effectiveReadOnly}
    />
  </>
}

export default FormItemCurrency;